import { render, staticRenderFns } from "./StaffInbox.vue?vue&type=template&id=5dab6f19&scoped=true&"
import script from "./StaffInbox.vue?vue&type=script&lang=ts&"
export * from "./StaffInbox.vue?vue&type=script&lang=ts&"
import style0 from "./StaffInbox.vue?vue&type=style&index=0&id=5dab6f19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab6f19",
  null
  
)

export default component.exports